/*
 * © 2020 Microsoft. All rights reserved.
 */

define('MenuUI/DealWarningModal',['pixi', 'absolute', 'MenuUI/MsftModal', 'lodash', 'Arkadium/GameEngine/Core/EngineManagers', 'util/NineSliceButton',
    'util/eventhandler', 'Managers/ScaleManager', 'util/CustomWordWrapper', 'MenuUI/ControlFocusManager'],
    function (PIXI, Absolute, MsftModal, _, EngineManagers, NineSliceButton,
        EventHandler, ScaleManager, CustomWordWrapper, ControlFocusManager) {

        var DealWarningModal = function (parent, dialogHeadline, dialogBody, playAction, cancelAction, closeButtonText) {
            this.initDealWarningModal(parent, dialogHeadline, dialogBody, playAction, cancelAction, closeButtonText);
        };

        DealWarningModal.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

        DealWarningModal.prototype.initDealWarningModal = function (parent, dialogHeadline, dialogBody, playAction, cancelAction, closeButtonText) {
            PIXI.DisplayObjectContainer.call(this);
            this.layoutType = 'large';
            this.parentToAdd = parent;
            this.buildOverlay();
            this.parentToAdd.addChild(this);
            this.popupContainer = new PIXI.DisplayObjectContainer();
            var width = Absolute.Coords.x(820),
                height = Absolute.Coords.y(350),
                graphics, overlay, icon, title, body,
                popupBkg = new PIXI.Sprite.fromFrame('warning_dialogues/_cmn_backgroundTile.png');
            overlay = new PIXI.Sprite.fromFrame('warning_dialogues/_cmn_UI2_bg_vignette.png');
            overlay.width = width;
            overlay.height = height;
            overlay.alpha = 0.6;
            graphics = new PIXI.Graphics();
            graphics.beginFill(0xfdfeff);
            graphics.lineStyle(5, 0xfdfeff);
            graphics.drawRect(0, 0, width, height);
            icon = new PIXI.Sprite.fromFrame('warning_dialogues/_cmn_popup_image_alert.png');
            icon.position.set(Absolute.Coords.x(30), Absolute.Coords.y(30));
            icon.width = Absolute.Coords.x(135);
            icon.height = Absolute.Coords.y(160);
            this.icon = icon;
            this.titleFontSize = 43;
            var titleStyle = {
                font: Absolute.ScreenMetrics.getResScale() * this.titleFontSize + "px Arial",
                fontFamily: 'segoe',
                fill: '#ffffff',
                tint: 0xffffff,
                align: 'left'
            };
            title = new PIXI.Text(Absolute.StringManager(dialogHeadline), titleStyle);
            title.position.set(Absolute.Coords.x(195), Absolute.Coords.y(20));
            this.title = title;
            this.bodyFontSize = 28;
            var bodyStyle = {
                font: Absolute.ScreenMetrics.getResScale() * this.bodyFontSize + "px Arial",
                fontFamily: 'segoe',
                fill: '#ffffff',
                align: 'left',
                wordWrap: true,
                wordWrapWidth: Absolute.Coords.x(600)
            };
            body = new PIXI.Text(Absolute.StringManager(dialogBody), bodyStyle);
            body.position.set(Absolute.Coords.x(195), Absolute.Coords.y(100));
            this.body = body;
            var labelOptions = {
                font: Absolute.ScreenMetrics.getResScale() * 29 + "px Arial",
                fontFamily: 'segoe',
                fill: '#ffffff',
                align: 'left',
                anchor: {
                    x: 0.5,
                    y: 0.5
                },
                x: Absolute.Coords.x(0),
                y: Absolute.Coords.y(3)
            };
            this.playButton = new NineSliceButton(
                'warning_dialogues/popup_button_Play_click.png',
                'warning_dialogues/popup_button_Play_over.png', 'warning_dialogues/popup_button_Play.png',
                Absolute.Coords.x(335), Absolute.Coords.y(100), 25, 25, 25, 25, Absolute.StringManager('buttons.ok'), labelOptions);
            this.playButton.onClick.add(playAction);
            var btnText = closeButtonText ? Absolute.StringManager(closeButtonText) : Absolute.StringManager('buttons.cancel');
            this.closeButton = new NineSliceButton(
                'warning_dialogues/popup_button_Cancel_click.png',
                'warning_dialogues/popup_button_Cancel_over.png', 'warning_dialogues/popup_button_Cancel.png',
                Absolute.Coords.x(335), Absolute.Coords.y(100), 25, 25, 25, 25, btnText, labelOptions);
            this.closeButton.onClick.add(cancelAction);
            this.popupContainer.addChild(graphics);
            this.popupContainer.addChild(popupBkg);
            this.popupContainer.addChild(overlay);
            this.popupContainer.addChild(icon);
            this.popupContainer.addChild(title);
            this.popupContainer.addChild(body);
            this.popupContainer.addChild(this.playButton);
            this.popupContainer.addChild(this.closeButton);
            this.addChild(this.popupContainer);
            this.popupContainer.visible = true;
            this.playButton.anchor.set(0.5, 0.5);
            this.closeButton.anchor.set(0.5, 0.5);
            this.playButton.position.set(width / 2 - (this.playButton.width / 2), Absolute.Coords.y(280));
            this.closeButton.position.set(width / 2 + (this.closeButton.width / 2), Absolute.Coords.y(280));
            this.initForceScaleSprite();
            ScaleManager.addElement(this, { scaleChangeSource: 'Full' });
            this.controlFocusManager = new ControlFocusManager();

            this.controlFocusManager.addControl(this.playButton, true, null, 0);
            this.controlFocusManager.addControl(this.closeButton, true, null, 1);

            this.controlFocusManager.unfocusCurrentControl();
            this.controlFocusManager.focusCurrentControl();
        };

        DealWarningModal.prototype.initForceScaleSprite = function () {
            this.forceScaleSprite = PIXI.Sprite.fromFrame("Buttons/SubMenuBack/SubMenuBack-Up.png");
            this.forceOffsetX = Absolute.Coords.x(20);
            this.forceOffsetY = Absolute.Coords.y(20);
            this.forceScaleSprite.width = Absolute.Coords.x(835);
            this.forceScaleSprite.height = Absolute.Coords.y(365);
            this.forceScaleSprite.alpha = 0;
            this.addChild(this.forceScaleSprite);
        };

        DealWarningModal.prototype.handleResize = function () {
            if (ScaleManager.scaleFactorX <= 0.35) {
                this.changeToSmallLayout('small');
            } else {
                this.changeToLargeLayout('large');
            }
            this.updateBodyTextCustomWrap();
            if (this.parent) this.updateTransform();
            var oldScaleX = this.scale.x, oldScaleY = this.scale.y;
            this.scale.set(1, 1);
            var initialWidth = this.width, initialHeight = this.height;
            this.scale.set(oldScaleX, oldScaleY);
            var screenScaleX = Absolute.Coords.x(1920) / ScaleManager.width,
                screenScaleY = Absolute.Coords.y(1080) / ScaleManager.height,
                roomWidth = ScaleManager.width, roomHeight = ScaleManager.height;
            this.width = initialWidth * screenScaleX;
            this.height = initialHeight * screenScaleY;
            var realWidth = this.width / screenScaleX, realHeight = this.height / screenScaleY;
            var widthToShow = initialWidth, heightToShow = initialHeight;
            var tookCare = false;
            if (realWidth > roomWidth) {
                this.width = Absolute.Coords.x(1920);
                var delta = roomWidth / widthToShow;
                this.height = ((initialHeight * screenScaleY) * delta);
                if ((this.height / screenScaleY) > roomHeight) {
                    this.height = Absolute.Coords.y(1080);
                    var delta = roomHeight / heightToShow;
                    this.width = ((initialWidth * screenScaleX) * delta);
                }
                tookCare = true;
            }
            if (!tookCare && (realHeight > roomHeight)) {
                this.height = Absolute.Coords.y(1080);
                var delta = roomHeight / heightToShow;
                this.width = ((initialWidth * screenScaleX) * delta);
                if ((this.width / screenScaleX) > roomWidth) {
                    this.width = Absolute.Coords.x(1920);
                    var delta = roomWidth / widthToShow;
                    this.height = ((initialHeight * screenScaleY) * delta);
                }
            }
            this.x = (Absolute.Coords.x(1920) * .5) - (this.width / 2) + this.forceOffsetX;
            this.y = (Absolute.Coords.y(1080) * .5) - (this.height / 2) + this.forceOffsetY;
        };

        DealWarningModal.prototype.changeToSmallLayout = function (layoutType) {
            if (this.layoutType === layoutType) return;
            this.icon.visible = false;
            this.title.position.set(this.icon.x, this.icon.y);
            this.title.style.font = Absolute.ScreenMetrics.getResScale() * (this.titleFontSize + 7) + "px Arial";
            this.title.updateText();
            this.body.x = this.icon.x;
            this.body.style.font = Absolute.ScreenMetrics.getResScale() * (this.bodyFontSize + 7) + "px Arial";
            this.body.style.wordWrapWidth = Absolute.Coords.x(750);
            this.body.updateText();
            this.layoutType = layoutType;
        };

        DealWarningModal.prototype.changeToLargeLayout = function (layoutType) {
            if (this.layoutType === layoutType) return;
            this.icon.visible = true;
            this.title.position.set(Absolute.Coords.x(195), Absolute.Coords.y(20));
            this.title.style.font = Absolute.ScreenMetrics.getResScale() * this.titleFontSize + "px Arial";
            this.title.updateText();
            this.body.position.set(Absolute.Coords.x(195), Absolute.Coords.y(100));
            this.body.style.font = Absolute.ScreenMetrics.getResScale() * this.bodyFontSize + "px Arial";
            this.body.style.wordWrapWidth = Absolute.Coords.x(600);
            this.body.updateText();
            this.layoutType = layoutType;
        };

        DealWarningModal.prototype.buildOverlay = function () {
            this.screenOverlay = new PIXI.Graphics();
            this.screenOverlay.beginFill(0x000000);
            this.screenOverlay.drawRect(0, 0, Absolute.Coords.x(10000), Absolute.Coords.y(10000));
            this.screenOverlay.alpha = 0.8;
            this.screenOverlay.interactive = true;
            this.bindScreenOverlayInteractions();
            this.parentToAdd.addChild(this.screenOverlay);
        };

        DealWarningModal.prototype.bindScreenOverlayInteractions = function () {
            this.screenOverlay.mouseover = function (evt) {
            };
            this.screenOverlay.mouseout = function (evt) {
            };
            this.screenOverlay.mousedown = function (evt) {
            };
            this.screenOverlay.mouseup = function (evt) {
            };
            this.screenOverlay.touchstart = function (evt) {
            };
            this.screenOverlay.touchend = function (evt) {
            };
            this.screenOverlay.touchendoutside = function (evt) {
            };
        };

        DealWarningModal.prototype.updateBodyTextCustomWrap = function () {
            var wrapWidth = Absolute.Coords.x((this.layoutType === 'small') ? 750: 600);
            CustomWordWrapper.doTextCustomWrap(
                this.body, this.bodyFontSize * Absolute.ScreenMetrics.getResScale(),
                '', wrapWidth, Absolute.Coords.y(100)
            );
        };

        DealWarningModal.prototype.close = function () {
            if (this.parent && this.parent.game && this.parent.game.gameScreenUI)
                this.parent.game.gameScreenUI.warning = null;

            this.parentToAdd.removeChild(this.screenOverlay);
            this.parentToAdd.removeChild(this);
            ScaleManager.removeElement(this);
        };

        DealWarningModal.prototype.handleCommand = function (command) {
            switch (command) {
                case 'Tab':
                case 'Right':
                    this.controlFocusManager.focusNextControl(1);
                    break;
                case 'ShiftTab':
                case 'Left':
                    this.controlFocusManager.focusNextControl(-1);
                    break;
                case 'Activate':
                    this.controlFocusManager.activateCurrentControl();
                    break;

            }
        };

        return DealWarningModal;
    });

